import { createContext } from "react";

export type ThemeContextType = {
	activeTheme: string;
	setActiveTheme: (theme: string) => void;
	availableThemes: {
		name: string;
		className: string;
	}[];
};

export const ThemeContext = createContext<ThemeContextType | undefined>(
	undefined,
);
